import React from 'react';
import { SalesChannelMode } from 'src/types/common/SalesChannel';
import { useSalesChannel } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { get } from 'lodash';
import { generateNoneLinkDataWithoutDragID } from 'src/constrains/LinkLibrary/tools';

const useScopeAndProps = ({
  onDataChange,
  data,
}: {
  onDataChange: (a: any) => void;
  data: any;
}) => {
  const { salesChannelUuid: uuid } = data || {};
  const currentSalesChannel = useSalesChannel();
  const currentUuid = get(currentSalesChannel, 'uuid');
  const [selectSalesChannelUuid, setSelectedSalesChannelUuid] =
    React.useState(uuid);

  React.useEffect(() => {
    if (uuid) {
      if (selectSalesChannelUuid !== uuid) {
        setSelectedSalesChannelUuid(uuid);
      }
    } else {
      onDataChange({
        ...(data || {}),
        salesChannelUuid: currentUuid,
      });
      setSelectedSalesChannelUuid(currentUuid);
    }
  }, [currentUuid]);

  React.useEffect(() => {
    if (uuid) {
      if (selectSalesChannelUuid !== uuid) {
        setSelectedSalesChannelUuid(uuid);
      }
    }
  }, [uuid]);

  const mode = get(currentSalesChannel, 'siteMode');
  const sisterSalesChannel = get(currentSalesChannel, 'sisterSalesChannel');

  const selectableSalesChannels = React.useMemo(() => {
    // [currentSalesChannel];
    if (mode === SalesChannelMode.ECOMMERCE || mode === SalesChannelMode.INFO) {
      return [currentSalesChannel];
    } else {
      if (get(sisterSalesChannel, 'uuid')) {
        return [currentSalesChannel, sisterSalesChannel];
      } else {
        return [currentSalesChannel];
      }
    }
  }, [currentUuid]);

  const handleOnSalesChannelChange = (uuid) => {
    if (onDataChange) {
      onDataChange({
        ...generateNoneLinkDataWithoutDragID(),
        salesChannelUuid: uuid,
      });
    }
    setSelectedSalesChannelUuid(uuid);
  };
  return {
    selectableSalesChannels,
    selectSalesChannelUuid,
    onSelectSalesChannelChange: handleOnSalesChannelChange,
  };
};
export { useScopeAndProps };
